import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';
import { JAR_TYPES } from '../three/jarMeta';
import { COLORS, LINE_NAMES } from '../../constants';

const EASE = [0.22, 1, 0.36, 1];

const KitSummary = ({ items, kitFunction, total, onAddToCart, onReset, onRandom, onRecommend }) => {
  const { t } = useLanguage();

  return (
    <motion.div
      className="kit-summary"
      initial={{ opacity: 0, y: 24, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.4, ease: EASE }}
      data-testid="kit-summary"
    >
      <div className="kit-summary-head">
        <div>
          <span className="eyebrow">{t('home.mix.complete_title')}</span>
          <h3 className="kit-summary-title" data-testid="kit-summary-title">{t('home.mix.complete_sub')}</h3>
          <span className="kit-volume" data-testid="kit-volume">{t('home.mix.volume')}</span>
        </div>
        <motion.div className="kit-function" initial={{ opacity: 0, x: 16 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.75, duration: 0.45, ease: EASE }} data-testid="kit-function">
          <span>{t('home.mix.function_label')}</span>
          <strong className="text-gradient-brand">{kitFunction}</strong>
        </motion.div>
      </div>

      <ul className="kit-summary-list">
        {items.map((p, i) => (
          <motion.li
            key={p.id}
            className="kit-summary-item"
            style={{ '--line': COLORS[p.line_color] }}
            initial={{ opacity: 0, y: 18, scale: 0.94 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ delay: 0.12 + i * 0.11, duration: 0.45, ease: EASE }}
            data-testid={`kit-summary-item-${p.product_type}`}
          >
            <span className="kit-summary-type">{t(JAR_TYPES[p.product_type].nameKey)}</span>
            <strong>{p.main_ingredient || p.ingredients?.[0]}</strong>
            <span className="kit-summary-effect">{p.effect || p.benefit}</span>
            <span className="mix-info-line"><i />{LINE_NAMES[p.line_color]} · {t('home.mix.volume_each')}</span>
          </motion.li>
        ))}
      </ul>

      <motion.div className="kit-summary-actions" initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.85, duration: 0.4, ease: EASE }}>
        <p className="kit-summary-note" data-testid="kit-summary-note">{t('home.mix.name_after_hint')}</p>
        <div className="kit-summary-cta">
          <button onClick={onAddToCart} className="btn-pill btn-pill-primary" data-testid="mix-add-to-cart">
            {t('home.mix.cta')} · €{total.toFixed(2)}
          </button>
          <div className="mix-actions-row">
            <button onClick={onRecommend} className="btn-pill btn-pill-ghost" data-testid="mix-recommend">{t('home.mix.recommend')}</button>
            <button onClick={onRandom} className="btn-pill btn-pill-ghost" data-testid="mix-random">{t('home.mix.random')}</button>
            <button onClick={onReset} className="btn-pill btn-pill-ghost" data-testid="mix-reset">{t('home.mix.reset')}</button>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default KitSummary;
